module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Prelims-head"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("For Karen, Wendy, Sandra and Dr Philips for the support bubble post ICU.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("For all the ICU staff, both permanent and redeployed, the “eyes have it” has always from the start been dedicated to you.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("To the sadly now departed patients that inspired “off” and “the last tear”, I hope I’ve honoured your life and your families in some  small way.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("To my family and friends for their love and support over the years, too many to name but you know who you are.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("My two children: kids, I’ve done this to show you the way and what’s possible.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("To the poets William Blake, Roald Dahl, Henry Normal (fellow Nottinghamshire Lad!) and Pam Ayers, all of them an inspiration in one way or another.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("And finally, but not least Maja. The person who gave me the vision and courage to start this process and see it through with me, the words may be mine, but you were always the inspiration.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1451ecf9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398433502_EPUB4.vue
// module id = 69
// module chunks = 0